// Автоповтор задачи, упавшей на временном отказе LLM (прокси, сеть, 429/5xx): подпись под бейджем
// «Ошибка» во вкладке «Задания». Без неё задача выглядит просто упавшей, и пользователь жмёт
// «Переобработать», не зная, что через несколько минут она перезапустится сама. Логика вне
// TasksManager.jsx, чтобы её можно было проверить без рендера.

const formatTime = (date, timeZone) => {
  const options = { hour: '2-digit', minute: '2-digit' };
  try {
    return date.toLocaleTimeString('ru-RU', timeZone ? { ...options, timeZone } : options);
  } catch {
    // Неизвестный часовой пояс из настроек не должен ронять строку таблицы.
    return date.toLocaleTimeString('ru-RU', options);
  }
};

/**
 * Подпись автоповтора для строки задачи: { label, title } или null, если повтор не назначен.
 * Только у упавшей задачи: раздав повтор, сервер снимает autoRetryAt, а у задачи в другом статусе
 * пометка была бы устаревшей.
 */
export const describeTaskAutoRetry = (task, timeZone) => {
  if (task?.status !== 'Failed' || !task?.autoRetryAt) {
    return null;
  }

  const retryAt = new Date(task.autoRetryAt);
  if (Number.isNaN(retryAt.getTime())) {
    return null;
  }

  const attempt = Number.isInteger(task.autoRetryCount) && task.autoRetryCount > 0 ? task.autoRetryCount : null;
  return {
    label: `Автоповтор в ${formatTime(retryAt, timeZone)}`,
    title: attempt
      ? `Сбой LLM временный — задача перезапустится сама. Автоповтор № ${attempt}.`
      : 'Сбой LLM временный — задача перезапустится сама.'
  };
};
